// Invite links (BP-87): error codes returned by preview/accept endpoints
export const INVITE_LINK_ERRORS = {
  NOT_FOUND: 'not_found',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
  EXHAUSTED: 'exhausted',
  ARCHIVED: 'archived',
  FULL: 'full',
  BLOCKED: 'blocked',
} as const;

export type InviteLinkError = typeof INVITE_LINK_ERRORS[keyof typeof INVITE_LINK_ERRORS];

// Invite link creation presets (defaults applied server-side)
export const INVITE_LINK_PRESETS = {
  ONE_TIME: 'one_time',
  MULTI_USE: 'multi_use',
} as const;

export type InviteLinkPreset = typeof INVITE_LINK_PRESETS[keyof typeof INVITE_LINK_PRESETS];

// Invite link lifecycle state (derived server-side, returned in list responses)
export const INVITE_LINK_STATES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
  EXHAUSTED: 'exhausted',
} as const;

export type InviteLinkState = typeof INVITE_LINK_STATES[keyof typeof INVITE_LINK_STATES];

// Telegram Mini App start_param prefix for invite links: startapp=inv_<token>
export const INVITE_LINK_START_PARAM_PREFIX = 'inv_';
